import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ScreenEmail as ScreenEmailFemale } from '../../../OwnAI/screens/Email';
import { ScreenEmail as ScreenEmailMale } from '../../../OwnAIMan/screens/Email';
import { LayoutDataType } from '../../types';

export const ScreenEmail: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenEmailMale />;
  }

  return <ScreenEmailFemale />;
};
